import styled from "styled-components";
import { getTheme, } from "@bracket/ui";
import { Text as Tx, type TextProps, } from "./Text";
import type { Optional, } from "@bracket/types";
import type { ReactNode, MouseEventHandler, } from "react";



export declare type ClickToProps = Optional<TextProps, "children"> & {
	onClick: MouseEventHandler<HTMLAnchorElement>;
	children: string | string[] | ReactNode;
	as?: "span"|"a";
}


export const ClickTo = ({ onClick, children, as = "a", ...rest }: ClickToProps) => {
	return (
		<ClickToText onClick={onClick}><Tx {...rest} as={"span"}>{children}</Tx></ClickToText>
	)
}

export const ClickToText = styled.a`
	text-decoration: none;
	> span {
		cursor: pointer;
		color: ${() => getTheme().primary };
		&:hover {
			text-decoration: underline;
		}
		&:visited {
			opacity: 0.8;
		}
	}
`;
